import { SVGAttributes } from "react";

export function ArchiveIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.5829 0.799805H5.41621C5.41621 0.799805 4.51981 0.799805 4.51981 1.6998H13.4793C13.4793 0.799805 12.5829 0.799805 12.5829 0.799805ZM15.2712 3.4998C15.2712 2.5998 14.3757 2.5998 14.3757 2.5998H3.62431C3.62431 2.5998 2.72881 2.5998 2.72881 3.4998V4.3998H15.2712V3.4998ZM17.0622 4.3998L16.533 3.867V5.2998H1.46701V3.867L0.936909 4.3998C0.406809 4.9326 0.0270091 5.0748 0.240309 6.1998C0.452709 7.3212 1.48141 13.4682 1.63441 14.2998C1.80181 15.2124 2.72971 15.1998 2.72971 15.1998H15.2721C15.2721 15.1998 16.1991 15.2124 16.3674 14.2998C16.5204 13.4682 17.5482 7.3212 17.7615 6.1998C17.973 5.0748 17.5932 4.9326 17.0622 4.3998ZM12.6 9.7971C12.6 10.2957 12.1959 10.6998 11.6973 10.6998H6.30271C6.0633 10.6998 5.83369 10.6047 5.6644 10.4354C5.49512 10.2661 5.40001 10.0365 5.40001 9.7971V7.9998H6.30001V9.7998H11.7V7.9998H12.6V9.7971Z"
        fill="url(#paint0_linear_9082_4034)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9082_4034"
          x1="20.4672"
          y1="0.799806"
          x2="-0.968449"
          y2="17.1621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#193446" />
          <stop offset="1" stopColor="#556D7C" />
        </linearGradient>
      </defs>
    </svg>
  );
}
